import React, { FunctionComponent } from "react";

import { bemClassNames, transformKeysToParamCase } from "@multiweb/reactUtils";
import { AccessibilityProps } from "@multiweb/types/react";
import { Icon, IconColor, IconProps } from "../Icon";
import { BackgroundAttributeProps } from "../types";

export type IconWithBackgroundAttrProps = IconProps & BackgroundAttributeProps & Pick<AccessibilityProps, "role" | "tabIndex" | "hideOutlineOnFocus" | "ariaChecked" | "ariaDisabled">;

const classNames = bemClassNames("icon-with-backgroundattr");

/** Komponent pro zobrazení ikony obalené v BackgroundAttr. Barva textu ikony je pak nastavena na základě hodnoty BackgroundAttr. */
export const IconWithBackgroundAttr: FunctionComponent<IconWithBackgroundAttrProps> = ({
    color,
    hasBackgroundAttr,
    ...restProps
}) => (
    <span className={classNames(transformKeysToParamCase({
        hasBackgroundAttr,
    }))}>
        <Icon {...restProps} color={hasBackgroundAttr ? IconColor.inherit : color} />
    </span>
);
